// import { Menubar } from '../../components/font-end/MasterLayout/Menubar';
import { useTranslation } from 'react-i18next';
import { ProfileService } from '../../components/font-end/Profile/ProfileService';
import { SuccessfullyUniformSurvey } from '../../components/font-end/UniformSurvey/SuccessfullyUniformSurvey';
import UniformImage from "../../components/font-end/UniformSurvey/UniformImage";

export const SuccessfullyChooseUniform = (props: any) => {
  let { t } = useTranslation();

  return (
    <>
      <ProfileService logo="show" />
      <SuccessfullyUniformSurvey />
      {/* <Menubar /> */}
    </>
  );
};
